/**
 * Check the email address
 * @param email
 */
const isEmailValid = (email: string): boolean => {
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(email);
}

/**
 * Check the phone number
 * @param phoneNumber
 */
const isPhoneNumberValid = (phoneNumber: string): boolean => {
    const phoneRegex = /^([0-9()/+ -]*)$/;
    return phoneRegex.test(phoneNumber)
}

export { isEmailValid, isPhoneNumberValid }